import { render, staticRenderFns } from "./unitEntryBodyRepairByInsurance.vue?vue&type=template&id=571ca2a6&scoped=true"
import script from "./unitEntryBodyRepairByInsurance.vue?vue&type=script&lang=js"
export * from "./unitEntryBodyRepairByInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571ca2a6",
  null
  
)

export default component.exports